import { render, staticRenderFns } from "./atendimento_nova_anaminese.vue?vue&type=template&id=c8f80726&scoped=true&"
import script from "./atendimento_nova_anaminese.vue?vue&type=script&lang=js&"
export * from "./atendimento_nova_anaminese.vue?vue&type=script&lang=js&"
import style0 from "./atendimento_nova_anaminese.vue?vue&type=style&index=0&id=c8f80726&scoped=true&lang=css&"
import style1 from "./atendimento_nova_anaminese.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f80726",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VProgressCircular,VTextField})
